import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import 'tailwindcss/dist/tailwind.min.css';
import './main.scss';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
